import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledDividerProps } from './BookingStageDivider.types';

export const StyledDivider = styled.div<IStyledDividerProps>`
  width: ${rem('22px')};
  margin: ${rem('0px')};
  border-bottom: ${rem('1px')} solid;
  border-color: ${({ theme }) => theme.colors.cross.silverFox};
  ${({ isAccepted, theme }) =>
    isAccepted &&
    `
    border-color: ${theme.colors.cross.greenMint};
  `}
`;
